import { Component } from 'react';
import Button from '../../Button';
import NotificationItem from '../../Notifications/NotificationItem';
import styles from './style.m.less';

export default class NotificationAlert extends Component {
    componentWillUnmount() {
        const { onUnmount } = this.props;
        if (onUnmount) {
            onUnmount();
        }
    }
    render() {
        const { item, remainingCount, onShowMore } = this.props;
        const countMsgToDisplay = remainingCount > 15 ? ' many more ' : `+${remainingCount} other new `;
        return (
            <div className={styles.container}>
                <NotificationItem item={item} />
                {remainingCount ? (
                    <span className={styles.link}>
                        <Button kind="LINK" onClick={onShowMore} aria-hidden>
                            {countMsgToDisplay} notification{remainingCount === 1 ? '' : 's'}
                        </Button>
                    </span>
                ) : null}
            </div>
        );
    }
}
